import { render, staticRenderFns } from "./arrangeForm.vue?vue&type=template&id=9b6464d2&"
import script from "./arrangeForm.vue?vue&type=script&lang=js&"
export * from "./arrangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports